/** "+94.3%" / "-5.0%"; digits = 0 gives "+94%". */
export function formatReturn(value: number | null, digits = 1): string {
  if (value == null || !Number.isFinite(value)) return "—";
  const rounded = Number(value.toFixed(digits));
  const sign = rounded > 0 ? "+" : rounded < 0 ? "-" : "";
  return `${sign}${Math.abs(rounded).toLocaleString("en-US", {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  })}%`;
}

/** stocks5.MarketCap (USD billions) to "$4.6T" / "$85B" / "$7.2B". */
export function formatMarketCap(usdBillions: number | null): string {
  if (usdBillions == null || !Number.isFinite(usdBillions) || usdBillions <= 0) return "—";
  if (usdBillions >= 1000) return `$${(usdBillions / 1000).toFixed(1)}T`;
  if (usdBillions >= 10) return `$${Math.round(usdBillions)}B`;
  return `$${usdBillions.toFixed(1)}B`;
}

export function formatWeekDate(iso: string): string {
  return new Date(`${iso}T00:00:00Z`).toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
    timeZone: "UTC",
  });
}

const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

/** "10 Oct 2025", as on the post charts (en-GB would print "Sept"). */
export function formatDayMonthYear(iso: string): string {
  const [year, month, day] = iso.slice(0, 10).split("-").map(Number);
  return `${day} ${MONTHS[month - 1]} ${year}`;
}

const NAME_SUFFIX =
  /,?\s+(Inc\.?|Incorporated|Corporation|Corp\.?|Public Limited Company|Companies|Company|&\s*Co\.?|Co\.?|plc|Ltd\.?|N\.V\.|S\.A\.|Holdings|Holding)$/i;

/**
 * "Seagate Technology Holdings plc" -> "Seagate Technology", "The Charles Schwab
 * Corporation" -> "Charles Schwab", as in bank research tables.
 */
export function shortCompanyName(name: string): string {
  let short = name.trim().replace(/^The\s+/i, "");
  while (NAME_SUFFIX.test(short)) short = short.replace(NAME_SUFFIX, "").trim();
  return short || name;
}
